import { useSelector } from 'react-redux';
import { useAdminMode } from '@/hooks/useAdminMode';
import { selectAdvisorAdminPortalState } from '@/model/selectors';
import { AdminModeToggle } from './AdminModeToggle';
import { AdminSearchBar } from './AdminSearchBar';
import { SelectedAdvisorBar } from './SelectedAdvisorBar';

interface AdminModeBannerProps {
  /** Hide banner when parent component controls admin mode externally */
  hidden?: boolean;
}

export function AdminModeBanner({ hidden = false }: AdminModeBannerProps) {
  const {
    isWizardUser,
    isAdminModeEnabled,
    hasSelectedAdvisor,
    handleAdvisorSelected,
    handleToggleChange,
    handleChangeAdvisor,
  } = useAdminMode();

  const { selectedAdvisor } = useSelector(selectAdvisorAdminPortalState);

  // Only render for wizard users when not hidden
  if (!isWizardUser || hidden) {
    return null;
  }

  return (
    <div
      className={`sticky top-0 z-40 -mx-4 border-b px-4 py-2 sm:-mx-6 sm:px-6 lg:px-8 ${
        isAdminModeEnabled ? 'border-orange-200 bg-orange-50' : 'border-transparent bg-gray-50'
      }`}
    >
      <div className="flex items-center gap-6 pl-6">
        <AdminModeToggle
          enabled={isAdminModeEnabled}
          onToggle={handleToggleChange}
        />

        {isAdminModeEnabled && (
          <>
            <div className="h-4 w-px bg-orange-200" />
            {hasSelectedAdvisor && selectedAdvisor ? (
              <SelectedAdvisorBar
                advisor={selectedAdvisor}
                onChangeAdvisor={handleChangeAdvisor}
              />
            ) : (
              <AdminSearchBar onAdvisorSelected={handleAdvisorSelected} />
            )}
          </>
        )}
      </div>
    </div>
  );
}
